import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { highlightColor, navbarBlue } from '../../Classes/theme'
import { NAVBAR_SPACE } from '../Navbar/Navbar'
import { study_apps } from './app_ratings';
import Stars from './Stars';
import { Motion } from '../Motion/Motion';
import { Link, useNavigate } from 'react-router-dom';

const spaces = { xs: '80px', sm: '60px', md: '60px' };
const margin = '18px';

export default function Ratings() {
    const smallScreen = useMediaQuery("(max-width:670px)");
    const mediumScreen = useMediaQuery("(max-width:980px)");
    const navigate = useNavigate();

    return (
        <Box id="all_apps" sx={{ py: spaces, bgcolor: highlightColor, display: 'flex', flexDirection: 'column' }}>
            <Typography variant='big' sx={{ width: '100%', textAlign: 'center', mb: spaces }}>Studijní aplikace</Typography>
            <Container maxWidth='lg' sx={{ px: NAVBAR_SPACE }}>
                <Grid container columns={24} spacing={mediumScreen ? 3 : 4} sx={{}}>
                    {study_apps.map((app, i) => <Grid size={smallScreen ? 24 : { xs: 24, sm: 12, md: mediumScreen ? 12 : 8, lg: 8 }} key={"AppRating" + i} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Motion scale={smallScreen ? 1.02 : 1.03}>
                            <Box onClick={() => {
                                //navigate(app.link);
                            }} sx={{ cursor: 'pointer', bgcolor: app?.color || navbarBlue, borderRadius: '18px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)', width: '100%', height: '157px', display: 'flex', flexDirection: 'column', justifyContent: 'left' }}>
                                <Link style={{ display: 'flex', flexDirection: 'column', justifyContent: 'left', textDecoration: 'none', height: '100%', width: '100%' }} to={app.link}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                        <Box component={'img'} alt={app.name + " logo"} src={app.icon} sx={{ width: '70px', height: '70px', ml: margin, mt: margin }} />
                                        <Stars style={{ marginTop: margin, marginRight: margin, marginLeft: 'auto' }} value={app.rating} />
                                    </Box>
                                    <Typography variant='medium' sx={{ color: app.white ? '#1A1C1E' : 'white', width: '100%', textAlign: 'left', ml: margin, mt: margin }}>{app.name}</Typography>
                                </Link>
                            </Box>

                        </Motion>
                    </Grid>)}

                </Grid>
            </Container>
        </Box>
    )
}
